import { render, staticRenderFns } from "./FocusList.vue?vue&type=template&id=57cdfc8a&scoped=true&"
import script from "./FocusList.vue?vue&type=script&lang=js&"
export * from "./FocusList.vue?vue&type=script&lang=js&"
import style0 from "./FocusList.vue?vue&type=style&index=0&id=57cdfc8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cdfc8a",
  null
  
)

export default component.exports